import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import { ThemeProvider } from './components/theme/ThemeContext'
import { InitialDataProvider } from './contexts/InitialDataContext'

// Read SSR-injected data so the client's first render matches the server's
// render tree exactly — prevents React hydration mismatch and the brief
// unstyled loading-screen flash that occurs when isSSR differs between server
// and client.
const ssrData = (window as any).__INITIAL_DATA__ ?? {}

const root = document.getElementById('root')!
const appTree = (
  <React.StrictMode>
    <ThemeProvider>
      <InitialDataProvider data={ssrData}>
        <App />
      </InitialDataProvider>
    </ThemeProvider>
  </React.StrictMode>
)

// If the root already has SSR-rendered content, hydrate instead of render
// to preserve the server-rendered HTML and avoid a full re-render flash.
if (root.hasChildNodes()) {
  ReactDOM.hydrate(appTree, root)
} else {
  ReactDOM.render(appTree, root)
}

// Fade out static SEO content after React mounts
requestAnimationFrame(() => {
  const infoSection = document.getElementById('szozat-info')
  if (infoSection) {
    infoSection.classList.add('szozat-info--hidden')
    infoSection.addEventListener('transitionend', () => infoSection.remove(), {
      once: true,
    })
  }
})

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // When a new service worker is available, immediately activate it
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
    // Reload the page to get the new version
    window.location.reload()
  },
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
